<!-- eslint-disable no-unused-vars -->
<template>
    <div class="collection-index-item" @click="$router.push({ name: itemRoute, params: { lang: $route.params.lang, id: props.item.slug}})">
        <!-- <RouterLink :to="{ name: itemRoute, params: { lang: $route.params.lang, id: item.slug}}"> -->
            <div class="img-content" ref="imageBlock">
                <img v-if="imageData"
                    :src="imageData.source_url"
                    :width="data.width"
                    :height="data.height"
                    loading="lazy"
                    :srcset="data.srcset"
                    :sizes="`${data.width}px`"
                />
                <div class="coll-item-banner">
                    <p class="title" v-html="data.title"></p>
                </div>
            </div>
        <!-- </RouterLink> -->
    </div>
</template>

<style lang="scss">
a {
    display: inline;
    width: auto;
    height: auto;
}

@media only screen and (max-width: 1023px) {
    .collection-index-item {
        flex: 1 0 auto;
        height: 100%;
    }
}
@media only screen and (min-width: 1024px) {
    .collection-index-item {
        height: 100%;
        width: fit-content;
    }
}
.collection-index-item .img-content {
    position: relative;
    //cursor: pointer;
    height: 100%;
    img, video {
        height: 100%;
        width: auto;
        transition: transform 1s;
    }
}
p.title {
    font-weight: bold;
    display: block;
    width: 100%;
    white-space: nowrap; /* forces text to single line */
    overflow: hidden;
    text-overflow: ellipsis;
    margin-block: 0.5rem;
    margin: 0;
}
.coll-item-banner {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    //line-height: 1rem;
    // margin-right: 1rem;
    padding: 0.5rem;
    background: rgba(0,0,0,0.8);
    color: #fff;
}

.collection-index-item a .img-content:hover {
    .coll-item-banner {
        color: #8ebfd4;
    }
}
@media only screen and (max-width: 1023.9px) {
    .coll-item-banner {
        display: none;
    }
}
</style>

<script setup>
// eslint-disable-next-line no-unused-vars
import { reactive,ref,nextTick, computed } from 'vue'

import { useRouter, useRoute } from 'vue-router'
// eslint-disable-next-line no-unused-vars
import sirapi from '@/sirapi'

const router = useRouter()
const route = useRoute()

const imageBlock=ref(null)
const data = reactive({media: null,width: 0, height: 0, srcset: null, title: ""})
// eslint-disable-next-line no-undef
const props = defineProps(['item'])
// eslint-disable-next-line vue/no-setup-props-destructure
const imageData = props.item.featured_image

const itemRoute = computed( () => {
    switch(props.item.type) {
        case 'radio':
            return 'radio_detail'
        case 'post':
            return 'galerie_detail'
        default:
            return sirapi.getParentRoute(props.item.parent)
    }
})

if(props.item.title.rendered){
    let el=document.createElement('div')
    // eslint-disable-next-line vue/no-setup-props-destructure
    el.innerHTML = props.item.title.rendered
    data.title = el.textContent
} else {
    // eslint-disable-next-line vue/no-setup-props-destructure
    data.title = props.item.title
}

// eslint-disable-next-line no-unused-vars
function clickIt(){
    router.push({ name: itemRoute, params: { lang: route.params.lang, id: props.item.slug}})
}

nextTick().then(() => {
    const containerHeight = imageBlock.value.parentElement.offsetHeight
    if( imageData){
        const imageHeight = imageData.media_details.sizes.full.height
        
        data.media = imageData
        data.height = containerHeight
        data.width = Number(imageData.media_details.sizes.full.width) / imageHeight * containerHeight
        
        if(imageData.media_details.sizes.medium) data.srcset = `${imageData.media_details.sizes.medium.source_url} ${imageData.media_details.sizes.medium.width}w`
        if(imageData.media_details.sizes.medium_large) data.srcset += `, ${imageData.media_details.sizes.medium_large.source_url} ${imageData.media_details.sizes.medium_large.width}w`
        if(imageData.media_details.sizes.large) data.srcset += `, ${imageData.media_details.sizes.large.source_url} ${imageData.media_details.sizes.large.width}w`
        if(imageData.media_details.sizes.full) data.srcset += `, ${imageData.media_details.sizes.full.source_url} ${imageData.media_details.sizes.full.width}w`
    }
})





</script>